import { attemptWorkspaceHref } from '@examflow/learning-space';

/**
 * Where Session Runtime should return after exit / blocked launch.
 * Always Exam Space scoped by PlatformScope — never bare `/`.
 */
export function resolveAttemptExitHref(scope: {
  languageId?: string | null;
  examType?: string | null;
}): string {
  if (scope.languageId && scope.examType) {
    return attemptWorkspaceHref({
      languageId: scope.languageId,
      examType: scope.examType,
    });
  }
  return '/workspace';
}
